export const ActionTypes = {
    TOTAL_NOTIFICATION : "TOTAL_NOTIFICATION",
    SET_NOTIFICATION : "SET_NOTIFICATION",
    INCREMENT : "INCREMENT",
 }